import "./StateReportingScreen.scss";
import React, {useCallback, useEffect, useState} from "react";
import StateReportingListTableComponent from "./state-reporting-list-table/StateReportingListTableComponent";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {IRootReducerState} from "../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../shared/components/search/SearchComponent";

interface StateReportingScreenProps {

}

const FiltersInitialState: any = {
    search: '',
}

const StateReportingScreen = (props: StateReportingScreenProps) => {
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentNavParams("State Reporting","State Reporting"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
            };
            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData]);


    return (
        <div className={'state-reporting-screen screen'}>
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Report"}
                                id="search_input"
                                placeholder={""}
                                value={filterData.search}
                                onChange={handleSearch}
                            />

                        </div>
                    </div>
                    <>
                        <StateReportingListTableComponent filterData={filterData}/>
                    </>
                </div>
            </div>
        </div>
    );

};

export default StateReportingScreen;